import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { CmsSsbtBootstrapResponse } from '@nsftx/seven-client-retail-vue-sgp'

export const useCmsConfigStore = defineStore('cmsConfigStore', () => {
  const cmsConfig = ref<CmsSsbtBootstrapResponse | null>(null)

  const setCmsConfig = (config: CmsSsbtBootstrapResponse) => {
    cmsConfig.value = config
  }

  return {
    cmsConfig,
    setCmsConfig
  }
})
